module.exports = __webpack_public_path__ + "img/simiconnect.8b650c6f.png";